import { createContext, useContext } from "react";

type ModalContextType = {
  onClose: () => void;
};

const ModalContext = createContext<ModalContextType>({ onClose: () => {} });

export const ModalContextProvider = ModalContext.Provider;
export const useModalContext = () => useContext(ModalContext);
